import { TerminalEventMonitoring } from '@lightspeed-payments/payments-terminal-sdk'
import React, { Dispatch, FC } from 'react'
import VendNumber from 'vend-number'
import { TerminalInfo } from '../../../../helpers/lspay.types'
import { ConnectingToTerminal } from '../../../modal-states/ConnectingToTerminal'
import { RefundEvent } from '../hooks/use-lspay-refund-server-reducer/types'
import { useCreateRefund } from '../hooks/useCreateRefund'
import { Processing } from '../../../modal-states/Processing'

interface CreatingRefundProps {
  amount: VendNumber
  currency: string
  originalRegisterSalePaymentIds?: string[]
  registerId: string
  registerSaleId: string
  retailerPaymentTypeId: string
  registerSalePaymentId: string
  consentCollected: boolean
  dispatch: Dispatch<RefundEvent>
  terminalMonitoringInstance: TerminalEventMonitoring | null
  terminalInfo: TerminalInfo
}

export const CreatingRefund: FC<CreatingRefundProps> = ({
  amount,
  currency,
  originalRegisterSalePaymentIds,
  registerId,
  registerSaleId,
  retailerPaymentTypeId,
  registerSalePaymentId,
  consentCollected,
  dispatch,
  terminalMonitoringInstance,
  terminalInfo,
}) => {
  useCreateRefund({
    amount,
    currency,
    originalRegisterSalePaymentIds,
    registerId,
    registerSaleId,
    retailerPaymentTypeId,
    registerSalePaymentId,
    consentCollected,
    dispatch,
    terminalMonitoringInstance,
    terminalInfo,
  })
  if (consentCollected) {
    // If consent is collected, it should be card presented refund
    // which means we should connect to terminal
    return <ConnectingToTerminal integrationType="server-driven" />
  }

  return <Processing isRefund={true} />
}
